export function trimSpacesFromString(text: string): string {
  return text.replace(/\s/g, '');
}
